import { generatePaymentIntentApiCall, generateWidgetPaymentIntentApiCall } from '@guryou/api-client-gql';

import { PAYMENT_INTENT_GET } from '../types';

import { execute } from './actionWrapper';

const generatePaymentIntent =
  ({ reservationId, subscriptionId, productId, membershipId, email, firstname, lastname, phone }) =>
  async dispatch =>
    execute(
      dispatch,
      () =>
        generatePaymentIntentApiCall({
          reservationId,
          subscriptionId,
          productId,
          membershipId,
          email,
          firstname: firstname || null,
          lastname: lastname || null,
          phone: phone || null,
        }),
      PAYMENT_INTENT_GET,
      true
    );

const generateWidgetPaymentIntent =
  ({ reservationId, subscriptionId, productId, membershipId, email, firstname, lastname, phone }) =>
  async dispatch =>
    execute(
      dispatch,
      () =>
        generateWidgetPaymentIntentApiCall({
          reservationId,
          subscriptionId,
          productId,
          membershipId,
          email,
          firstname: firstname || null,
          lastname: lastname || null,
          phone: phone || null,
        }),
      PAYMENT_INTENT_GET,
      true
    );

export { generatePaymentIntent, generateWidgetPaymentIntent };
